module.exports = __webpack_public_path__ + "static/img/mojito.867bae7.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mojito.gif
// module id = Du8f
// module chunks = 4